import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Icon,
  Layer,
  Loading,
  Pane,
  PaneFooter,
  Paneset,
} from '@folio/stripes-components';
import { FormattedMessage } from 'react-intl';
import { Form } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';
import PatternDesign from './PatternDesign';

function BarcodePatternsForm({ initialValues, onHandleSubmit, isLoading }) {
  const renderPaneFooter = (submit, pristine, submitting, form) => {
    return (
      <PaneFooter
        renderEnd={
          <Button
            buttonStyle="primary"
            disabled={pristine || submitting}
            id="barcode-patterns-form-pane-footer-submit-btn"
            marginBottom0
            type="submit"
            onClick={(event) => {
              submit(event);
            }}
            onMouseDown={(e) => e.preventDefault()}
          >
            <FormattedMessage
              id="stripes-core.button.save"
              defaultMessage="Save"
            />
          </Button>
        }
        renderStart={
          <Button
            id="barcode-patterns-form-pane-footer-cancel-btn"
            marginBottom0
            onClick={() => form.reset()}
            onMouseDown={(e) => e.preventDefault()}
            disabled={pristine || submitting}
          >
            <FormattedMessage
              id="stripes-components.cancel"
              defaultMessage="Cancel"
            />
          </Button>
        }
      />
    );
  };
  return (
    <Form
      onSubmit={onHandleSubmit}
      initialValues={initialValues}
      mutators={{
        ...arrayMutators,
      }}
    >
      {({ handleSubmit, pristine, submitting, values }) => {
        return (
          <Paneset>
            <Pane
              id="inventory-plugin-template-barcode-patterns-pane"
              paneTitle={
                <FormattedMessage
                  id="ui-plugin-inventory-templates.barcode.patterns.pane.paneTitle"
                  defaultMessage="Barcode patterns"
                />
              }
              defaultWidth="fill"
              centeredContent
              footer={renderPaneFooter(handleSubmit, pristine, submitting)}
            >
              <form id="default-fields-form" onSubmit={handleSubmit}>
                <FieldArray
                  name="patternValues"
                  component={PatternDesign}
                  subscription={{ value: true }}
                />
                {/* <PatternDesign /> */}
                <hr />
                <pre>{JSON.stringify(values, 0, 2)}</pre>
              </form>
            </Pane>
          </Paneset>
        );
      }}
    </Form>
  );
}

BarcodePatternsForm.propTypes = {
  initialValues: PropTypes.object,
  onHandleSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default BarcodePatternsForm;
